module.exports = __webpack_public_path__ + "static/media/Graduated_Members.8f8a0f87.md";